import {useLogger} from '../context';
import * as React from 'react';

/**
 * returns true if the rendering is happening in the client as opposed to hydration or ssr rendering.
 */
export function useIsClientOnlyRendering(): boolean {
    const logger = useLogger().general;

    const isClient = React.useSyncExternalStore(
        () => {
            return () => {}; // we don't change the value, so we don't provide subscription
        },
        () => true, // snapshot is true on the client side
        () => false // snapshot is false on server and during hydration
    );

    logger.debug('client-only rendering: %s', isClient);

    return isClient;
}
